import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLines, FadeIn } from "@/components/Motion";

export default function PageHero({ image, overline, lines, sub, children, testid }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.02, 1.14]);

  return (
    <section
      ref={ref}
      data-testid={testid}
      className="relative flex min-h-[88vh] items-end overflow-hidden bg-[#0B2B22]"
    >
      <motion.div style={{ y, scale }} className="absolute inset-0 will-change-transform">
        <img src={image} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B2B22] via-[#0B2B22]/55 to-[#0B2B22]/20" />
      </motion.div>
      <div className="grain absolute inset-0" />
      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 pb-16 pt-40 sm:px-10 sm:pb-24 lg:px-16">
        {overline && (
          <FadeIn delay={0.05}>
            <p className="font-mono text-xs sm:text-sm font-bold uppercase tracking-[0.3em] text-[#7FB998]">
              {overline}
            </p>
          </FadeIn>
        )}
        <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.05] text-[#F4F7F4]">
          <MaskedLines lines={lines} />
        </h1>
        {sub && (
          <FadeIn delay={0.55}>
            <p className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-[#F4F7F4]/80">
              {sub}
            </p>
          </FadeIn>
        )}
        {children && (
          <FadeIn delay={0.7} className="mt-9 flex flex-wrap items-center gap-3">
            {children}
          </FadeIn>
        )}
      </div>
    </section>
  );
}
